import { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchHeldeskLocationInfo, ILocation } from '../../../../libraries/location';
import LocationsForm from '../../../components/location-edit/locations-form';
import Header from '../../../components/util/header';
import { Language } from '../../../languages/languageHandler';
import { AppState } from '../../../client-redux/reducers';
import './styles.scss';

enum MODE {
  READ = 'read',
  EDIT = 'edit',
  NEW = 'new'
}

const HelpdeskLocation = () => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);
  const currencyList = useSelector((state: AppState) => state.currencies.currencies);
  const { mode: modeParam, entid, sid } = useParams();

  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState<ILocation | null>(null);
  const [currencies] = useState<boolean>(true);
  const [, setNoResults] = useState<boolean>(false);
  const [, setStatusOperCode] = useState<number>();

  const mode = useMemo(() => {
    if (modeParam === MODE.NEW || modeParam === MODE.EDIT || modeParam === MODE.READ) return modeParam as MODE;
    return MODE.READ;
  }, [modeParam]);

  useEffect(() => {
    getLocationInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entid, sid]);

  const getLocationInfo = async () => {
    if (mode === MODE.NEW || !entid || !sid) {
      return;
    }

    try {
      setLoading(true);
      const location = await fetchHeldeskLocationInfo(currencies, Number(entid), Number(sid));
      if (location?.shops && location.shops.length > 0) {
        setLocation(location.shops[0]);
      } else {
        setNoResults(true);
        setLoading(false);
        setStatusOperCode(location.statusOper.code);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="local">
      <Header
        pageTitle={mode !== MODE.NEW ? `${lang.GLOBAL_LOCATION} ${entid}/${sid}` : `${lang.LOCATIONS_OPEN_NEW}`}
      />
      <LocationsForm
        lang={lang}
        location={location || null}
        currencyList={currencyList}
        loading={loading}
        mode={mode}
        workflow="helpdesk"
        reloadLocations={getLocationInfo}
      />
    </div>
  );
};

export default HelpdeskLocation;
